import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import axios from "axios";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter, useParams } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import { Link } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
// import ChooseFileExample from "../../secure/Contact/ChooseFileExample";
// import contactfile from "././../../../../file/Contact.xlsx"
import contactfile from "././../../../file/Contact.xlsx";
import RefreshIcon from "@mui/icons-material/Refresh";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useDispatch } from "react-redux";
import { BulkUploadList } from "../../../redux/features/pageSlices";
import Swal from "sweetalert2";

const ImportContact = ({ resetValue }) => {
  // .....................................................Scroll Bar.................................................................//
  const wrapper1Ref = useRef(null);
  const wrapper2Ref = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);

  const handleWrapper1Scroll = (e) => {
    wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
  };

  const handleWrapper2Scroll = (e) => {
    wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
  };

  const updateDivWidths = () => {
    if (div1Ref.current && div2Ref.current) {
      div1Ref.current.style.width =
        div2Ref.current.querySelector("table").offsetWidth + "px";
      div2Ref.current.style.width =
        div2Ref.current.querySelector("table").offsetWidth + "px";
    }
  };

  // ..................................................End Of Scroll Bar..............................................................//
  const customId1 = "custom-id-yess";

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const dispatch = useDispatch();

  const [hideupload, setHideUpload] = useState(true);
  const [data1, setData1] = useState([]);
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [data2, setData2] = useState([]);
  const [downloaddata, setDownloaddata] = useState("");
  const [open, setOpen] = useState();
  const [file, setFile] = useState("");
  const [arrayvalue, setArrayValue] = useState(null);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [totalPage, setTotalPage] = useState();
  const [totalPageCount, settotalPageCount] = useState();
  const [disabledPrevious, setDisabledPrevious] = useState(true);
  const [disableNext, setDisableNext] = useState(true);
  const [PageSize1, setPageSize1] = useState(10);
  const [pageNumber1, setPageNumber1] = useState(0);
  // ----------------------------------------Table-----------------------
  const [data, setData] = useState([]);
  // console.log("data table------", data1);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };
  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const approveUser = async (cpId) => {
    const res = await common_axios(`/admin/v1/user/approve/?cpId=${cpId}`);
    await setStatus("approved");

    // console.log(res.data);
  };
  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },
            {
              Header: "Phonebook Name",
              accessor: "phoneBookName",
            },
            {
              Header: "Uploaded By",
              accessor: "uploadedBy",
            },
            {
              Header: "Filename",
              accessor: "filename",
            },
            {
              Header: "Date",
              accessor: "fileUpload",
            },
            {
              Header: "Total Upload",
              accessor: "totalCount",
              Cell: (cell) => {
                return (
                  <>{cell.row.original.totalCount?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Allready Exist",
              accessor: "duplicateCount", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.duplicateCount?.toLocaleString("en-US")}
                  </>
                );
              },
            },

            {
              Header: "Total Success",
              accessor: "successCount", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.successCount?.toLocaleString("en-US")}</>
                );
              },
            },

            {
              Header: "Total Failure",
              accessor: "failureCount",
              Cell: (cell) => {
                return (
                  <>{cell.row.original.failureCount?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Status",
              accessor: "fileStatus",
              Cell: (cell) => (
                <div className="">
                  <p
                    className="btn color_1 cursor_Normal"
                    id="dropdownMenuButton1"
                    aria-expanded="false"
                  >
                    {/* {console.log("cell111", cell)} */}
                    {cell.row.original.fileStatus == 0 ? (
                      <>
                        <span class="badge bg-warning">Pending</span>
                      </>
                    ) : (
                      <>
                        <span class="badge bg-success ">Success</span>
                      </>
                    )}

                    {/* {/ <DeleteIcon /> /} */}
                  </p>
                </div>
              ),
            },

            {
              Header: "Download",
              accessor: "downloadUrl",
              Cell: (cell) => (
                <div className="">
                  {/* <a  href={cell.row.original.downloadUrl} > */}
                  <button
                    className="btn color_1 "
                    type="button"
                    id=""
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      downloadFile(cell);
                    }}
                  >
                    <FileDownloadIcon />
                  </button>
                  {/* </a> */}
                </div>
              ),
            },
          ]
        : [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              ),
            },
            {
              Header: "Phonebook Name",
              accessor: "phoneBookName",
            },
            {
              Header: "Filename",
              accessor: "filename",
            },
            {
              Header: "Date",
              accessor: "fileUpload",
            },
            {
              Header: "Total Upload",
              accessor: "totalCount",
              Cell: (cell) => {
                return (
                  <>{cell.row.original.totalCount?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Allready Exist",
              accessor: "duplicateCount",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.duplicateCount?.toLocaleString("en-US")}
                  </>
                );
              },
            },
            {
              Header: "Total Success",
              accessor: "successCount", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.successCount?.toLocaleString("en-US")}</>
                );
              },
            },

            {
              Header: "Total Failure",
              accessor: "failureCount",
              Cell: (cell) => {
                return (
                  <>{cell.row.original.failureCount?.toLocaleString("en-US")}</>
                );
              },
            },
            {
              Header: "Status",
              accessor: "fileStatus",
              Cell: (cell) => (
                <div className="">
                  <p
                    className="btn color_1  cursor_Normal"
                    id="dropdownMenuButton1"
                    aria-expanded="false"
                  >
                    {/* {console.log("cell111", cell)} */}
                    {cell.row.original.fileStatus == 0 ? (
                      <>
                        <span class="badge bg-warning">Pending</span>
                      </>
                    ) : (
                      <>
                        <span class="badge bg-success ">Success</span>
                      </>
                    )}

                    {/* {/ <DeleteIcon /> /} */}
                  </p>
                </div>
              ),
            },

            {
              Header: "Download",
              accessor: "downloadUrl",
              Cell: (cell) => (
                <div className="">
                  {/* <a  href={cell.row.original.downloadUrl} > */}
                  <button
                    className="btn color_1 "
                    type="button"
                    id=""
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      downloadFile(cell);
                    }}
                  >
                    <FileDownloadIcon />
                  </button>
                  {/* </a> */}
                </div>
              ),
            },
          ],
    [TableStatus]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  const uploadreset = () => {
    document.getElementById("fileName").value = "";
    setArrayValue(null);
  };
  //---------------------------------------------End table------------------------------------//
  function handleChange(event) {
    setFile(event.target.files[0]);
    setHideUpload(false);
  }
  function handleChange1(event) {
    setArrayValue(event.target.value);
  }
  // .....................................Formik............................................//
  async function ContactGet(values) {
    try {
      // setOpen(true);
      setHideSkeleton(true);

      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/phone-books/v2/list`
      );
      if (res.data.statusdescription.statusCode == 200) {
        // setOpen(false);
        setHideSkeleton(false);
        const mapp = res.data.listOfPlaysmsPhonebook.map(
          (x) => x.phonebookDescription
        );
        if (!mapp.includes("Default")) {
          const obj = {
            id: "1",
            phonebookName: "Default",
          };
          res.data.listOfPlaysmsPhonebook.push(obj);
        }
        setData1(res.data.listOfPlaysmsPhonebook);
      } else {
        setHideSkeleton(false);
        // setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  async function ChooseFile(event) {
    // console.log("qqq",arrayvalue)
    try {
      setOpen(true);

      if (arrayvalue == "0") {
        const formData = new FormData();
        // event.currentTarget.disabled = true; //to disable upload button after one click......
        formData.append("username", localStorage.getItem("usernamedisplayed"));
        formData.append("phone_book", file);
        formData.append("phoneBookId", "0");
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/upload`,
          formData
        );
        if (res.data.statusdescription.statusCode == 200) {
          document.getElementById("fileName").value = "";
          setOpen(false);
          setHideUpload(true);

          BulkTableget();
          setTimeout(() => {
            BulkTableget();
          }, 30000);
          // setDownloaddata(res.data.downloadUrl);
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "File uploaded successfully!!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setHideUpload(true);
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else {
        const formData = new FormData();
        // event.currentTarget.disabled = true; //to disable upload button after one click......
        formData.append("phone_book", file);
        formData.append("username", localStorage.getItem("usernamedisplayed"));
        formData.append("phoneBookId", arrayvalue?.id);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/upload`,
          formData
        );
        if (res.data.statusdescription.statusCode == 200) {
          document.getElementById("fileName").value = "";
          setHideUpload(true);
          dispatch(BulkUploadList(res.data));
          // setHide(true);
          setOpen(false);
          BulkTableget();
          setTimeout(() => {
            BulkTableget();
          }, 30000);
          setDownloaddata(res.data.downloadUrl);
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "File uploaded successfully!!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setHideUpload(true);
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Check Your Network");
    }
  }
  const username = localStorage.getItem("usernamedisplayed");
  async function BulkTableget() {
    setData([]);

    try {
      setOpen(true);
      const result = await common_axios(
        `${
          process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS
        }/user/v1/group-upload/fetch-all-data?username=${username}&pageNo=${
          TableStatus.pageNo
        }&pageSize=${TableStatus.pageSize}&status=${"Phone-Book"}`
      );

      // console.log("result get api.........", result);

      if (result.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setData(result.data.fileUploads.content);
        setData2(result.data.fileUploads);
        setDownloaddata(result.data.downloadUrl);
      } else {
        setData([]);
        // setTableLoader(false);
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // console.log(result.data.statusMessage);
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // const downloadFile = (cell) => {
  //   // console.log("hlooooooo",cell.row.original.downloadUrl);
  //   // alert("hii");
  //   window.location.href = cell.row.original.downloadUrl; //to download the file from url in download button
  //   BulkTableget();
  // };
  // ..........................................................................................................................//
  // const downloadFile = (cell) => {

  //   window.location.href = cell.row.original.downloadUrl; //to download the file from url in download button
  // };

  const downloadFile = async (cell) => {
    // console.log(cell.row.original,"kkjhh")
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.downloadUrl}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // UserId:`${localStorage.getItem('UserId')}`,
            // Source: "web",
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };

  useEffect(() => {
    BulkTableget();
  }, [TableStatus.pageSize, TableStatus.pageNo]);

  useEffect(() => {
    ContactGet();
  }, []);
  // console.log("aaaa",ContactArray)

  useEffect(() => {
    document.getElementById("fileName").value = "";

    setArrayValue(null);
  }, [resetValue]);

  // .............................................RefreshBtn API..................................................................//

  async function RefreshBtn() {
    setData([]);

    try {
      setOpen(true);
      const result = await common_axios(
        `${
          process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS
        }/user/v1/group-upload/fetch-all-data?username=${username}&pageNo=${
          TableStatus.pageNo
        }&pageSize=${TableStatus.pageSize}&status=${"Phone-Book"}`
      );

      // console.log("result get api.........", result);

      if (result.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setData(result.data.fileUploads.content);
        setData2(result.data.fileUploads);
        setDownloaddata(result.data.downloadUrl);
      } else {
        setData([]);
        // setTableLoader(false);
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // console.log(result.data.statusMessage);
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // ..........................................................................................................................//

  // ..........................................ScrollBar Useefffect.......................

  useEffect(() => {
    if (wrapper1Ref.current && wrapper2Ref.current) {
      wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
      wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
    }
    updateDivWidths();
    window.addEventListener("resize", updateDivWidths);
    return () => {
      window.removeEventListener("resize", updateDivWidths);
    };
  }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

  // .....................................................................//
  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="card-body px-0">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              Bulk Upload
            </span>
            <div className="card-body text-lg-start text-center">
              <section class="cmp">
                <div class="container-fluid">
                  <div class="row">
                    <section class="col-md-12 right_panel px-0">
                      <div class="tab-content" id="pills-tabContent">
                        <ThemeProvider theme={theme}>
                          <div
                            class="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            aria-labelledby="pills-home-tab"
                          >
                            {/* <input
                          type="file"
                          class="form-control w-40"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="enter mobile number"
                        />
                       
                        <p class="my-4">
                          <b class="text-capitalize">note:</b> File format
                          should be in csv/txt/xls/xlsx
                        </p>
                        <button
                          type="button"
                          class="btn btn-primary text-capitalize d-block ms-auto"
                        >
                          upload
                        </button> */}

                            <div className="card-body p-2 text-lg-start text-center">
                              <div className="row">
                                <div class="col-md-4">
                                  {hideSkeleton == true ? (
                                    <>
                                      <Box sx={{ width: "100%" }}>
                                        <Skeleton />
                                        <Skeleton animation={false} />
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      {/* <FormControl
                                        required
                                        fullWidth
                                        size="small"
                                      >
                                        <InputLabel
                                          id="demo-simple-select-autowidth-
                                    label"
                                        >
                                          Phonebook List
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-autowidth-label"
                                          id="demo-simple-select-autowidth"
                                          value={arrayvalue}
                                          onChange={handleChange1}
                                          autowidth
                                          label=" PhoneBook List"
                                        >
                                        
                                          {data1.map((arg) => {
                                            return (
                                              <MenuItem value={arg.id}>
                                                {" "}
                                                {arg.phonebookName}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={data1}
                                        getOptionLabel={(option) =>
                                          option.phonebookName
                                        }
                                        value={arrayvalue}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setArrayValue(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Add To Phonebook List"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                  {/* 
      <Autocomplete
                                  disablePortal
                                  // disabled={userAccountDisable}
                                  id="combo-box-demo"
                                  options={ContactArray}
                                  getOptionLabel={(option) =>
                                    `${option.groupName}`
                                  }
                                  // value={accountValue}
                                  onChange={(e, index) => {
                                    handleChange1(e, index);
                                  }}
                                  sx={{ width: 300 }}
                                  renderInput={(params) => (
                                    <TextField
                                      // value={accountValue}
                                      // required
                                      {...params}
                                      label="Select Contact List"
                                    />
                                  )}
                                /> */}
                                </div>
                                <div className="col-md-8">
                                  <div class="input-group ">
                                    <Button
                                      variant="contained"
                                      component="label"
                                      style={{
                                        backgroundColor: "white",
                                        boxShadow: "none",
                                        height: "40px",
                                        border: "1px solid #d2d6da",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px -3px 0px 0px",
                                      }}
                                    >
                                      <input
                                        id="fileName"
                                        type="file"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        onChange={handleChange}
                                        style={{ color: "#7b809a" }}
                                      />
                                    </Button>
                                    <div className="d-inline-flex mt-2">
                                      <span className="ms-4">
                                        {/* (Reference File) */}
                                      </span>
                                      <span>
                                        {/* <Link
                                          to={contactfile}
                                          target="_blank"
                                          download="Reference.xlsx"
                                          className="xlsx"
                                        >
                                          xlsx
                                        </Link> */}
                                        <a
                                          href={contactfile}
                                          target="_blank"
                                          download="Reference.xlsx"
                                          className="text-info"
                                        >
                                          {/* .xlsx */}( Sample File Format )
                                        </a>
                                      </span>
                                      {/* <Link to={contactfile} target="_blank" download="Reference.xlsx">
                  Download Here
                </Link> */}
                                    </div>

                                    {/* <button
                                      disabled={hideupload}
                                      type="button"
                                      className="btn btn_wt_8 bg-gradient-primary m-0 ms-5 radius d-flex align-items-center"
                                      style={{ width: "auto" }}
                                      onClick={ChooseFile}
                                    >
                                      Upload
                                      <FileUploadIcon
                                        style={{ fontSize: "17px" }}
                                      />
                                    </button>
                                    <div>
                                      <button
                                        onClick={uploadreset}
                                        type="button"
                                        className="btn bg-gradient-secondary ms-2 w_btn btn_w8 m-0"
                                       
                                      >
                                        Reset
                               
                                        <SettingsBackupRestoreRoundedIcon
                                          style={{ fontSize: "17px" }}
                                        />
                                      </button>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <p className=" mb-0  text text-start float-en p_51 mt-4">
                                {/* Field(s) marked with{" "} */}
                                Fields required in file Contact name, Mobile
                                Number, Email, Phone book
                                <span className="text-danger fw-bold"></span>
                              </p>
                              <div className="d-flex justify-content-between mt-2">
                                <button
                                  onClick={uploadreset}
                                  type="button"
                                  className="btn resetBtn_UP ms-2 w_btn btn_w8 m-0"
                                >
                                  Reset
                                  {/* <SettingsBackupRestoreRoundedIcon
                                    style={{ fontSize: "17px" }}
                                  /> */}
                                </button>

                                <button
                                  // disabled={hideupload}
                                  disabled={
                                    arrayvalue === "" ||
                                    file == 0 ||
                                    arrayvalue == null
                                  }
                                  type="button"
                                  className="btn btn_wt_8 m-0 ms-5 radius d-flex align-items-center dawnload_UP"
                                  style={{ width: "auto" }}
                                  onClick={ChooseFile}
                                >
                                  Upload
                                  {/* <FileUploadIcon
                                    style={{ fontSize: "17px" }}
                                  /> */}
                                </button>
                                {/* <div> */}

                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                        </ThemeProvider>
                      </div>
                    </section>
                  </div>
                </div>
              </section>

              {/* <section class="modal_1">
         
          <div
            class="modal fade"
            id="exampleModal6"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Modal title
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <form class="m-0">
                    <div class="">
                      <div class="row align-items-center">
                        <div class="col-4">
                          <label
                            for="exampleInputEmail1"
                            class="form-label m-0"
                          >
                            number list name:
                          </label>
                        </div>
                        <div class="col-8">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-4">
                          <label
                            for="exampleInputTextarea"
                            class="form-label m-0"
                          >
                            description:
                          </label>
                        </div>
                        <div class="col-8">
                          <textarea
                            class="form-control"
                            placeholder="Leave a comment here"
                            id="exampleInputTextarea"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="bxg_8 mt-3">
                      <div class="flt_start">
                        <div class="float-start d-flex align-items-center flex-wrap">
                          
                          <div class="form-check">
                            <div class="">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                onclick="radio_1()"
                              />
                            </div>
                            <label
                              class="form-check-label"
                              for="flexRadioDefault1"
                            >
                              from file
                            </label>
                          </div>
                          <div class="form-check ms-2">
                            <div class="">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                                onclick="radio_2()"
                                checked=""
                              />
                            </div>
                            <label
                              class="form-check-label"
                              for="flexRadioDefault2"
                            >
                              direct input
                            </label>
                          </div>
                        
                        </div>
                      </div>
                      <div class="row align-items-center my-2">
                        <div class="col-4">
                          <label
                            for="exampleInputEmail1"
                            class="form-label m-0"
                          >
                            upload from csv/txt/xls/xlsx
                          </label>
                        </div>
                        <div class="col-8">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <p>
                        <b class="text-capitalize">note:</b> jdksvc ewbhvber
                        webvweb vfvvwer fvewrre vferwver vfervgrv dfverv vfrev
                        vferver vfrerre vferver vrrervr
                      </p>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary d-flex align-items-center text-capitalize m-0 ms-auto mt-4"
                    >
                      <i class="fas fa-save d-block"></i>
                      <span class="d-block ms-1">upload & save</span>
                    </button>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" class="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section> */}
              {/* ---------------------------------Table------------------------------------------ */}

              {/* -------------------------------------End table------------------------------------------- */}
            </div>
          </div>
        </div>
        <div>
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              Bulk File Upload History
            </span>
            <div className="card-body text-lg-start text-center">
              {data?.length > 0 ? (
                <>
                  {/* ............................Table Code.................. */}
                  <div className="d-flex justify-content-between mt-3">
                    <select
                      value={TableStatus.pageSize}
                      className="dropdown"
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setTableStatus({
                          ...TableStatus,
                          pageSize: e.target.value,
                          pageNo: 0,
                        });
                      }}
                    >
                      {[10, 25, 50].map((value, i) => {
                        return (
                          <option
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                            value={value}
                            key={value}
                          >
                            Show {value}
                          </option>
                        );
                      })}
                    </select>

                    <Tooltip title="Refresh">
                      <button
                        type="submit"
                        className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                        // onClick={RefreshBtn}
                        onClick={() => RefreshBtn("Text to Copy")}
                      >
                        {/* <i class="material-icons opacity-10">refresh</i> */}
                        <RefreshIcon />
                      </button>
                    </Tooltip>
                    {/* <div className="d-flex align-items-center">
                      <TextField
                        className="ms-4 w-100"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      />
                    </div> */}
                  </div>
                  <div>
                    {selectedUserDetail != undefined && (
                      <div>
                        <button
                          ref={modelButtonReject}
                          type="button"
                          className="btn btn-primary d-none"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          Launch static backdrop modal
                        </button>

                        <div
                          className="modal fade"
                          id="staticBackdrop"
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"
                          tabindex="-1"
                          aria-labelledby="staticBackdropLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5
                                  className="modal-title"
                                  id="staticBackdropLabel"
                                >
                                  Are you sure you want to delete?
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>

                              {/* <div className="modal-body">
                                    <TextField
                                      disabled
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="rules"
                                      variant="outlined"
                                      size="small"
                                      value={selectedUserDetail.msisdn}

                                    />
                                  </div> */}

                              <div class="modal-body">
                                <div class="row">
                                  <div className="col-md-6 mt_2">
                                    <div class="col-6">
                                      <label
                                        for="exampleInputEmail1"
                                        className="form-label"
                                      >
                                        Mobile Number:
                                      </label>
                                    </div>

                                    <input
                                      disabled
                                      className="form-control"
                                      placeholder="Mobile Number"
                                      type="text"
                                      minLength="3"
                                      // value={selectedUserDetail?.dltId}
                                      value={selectedUserDetail.msisdn}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer justify-content-between">
                                <button
                                  type="button"
                                  className="btn btn-secondary w_btn"
                                  data-bs-dismiss="modal"
                                >
                                  No
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  data-bs-dismiss="modal"
                                  // onClick={() => {
                                  //   rejectUserApi();
                                  // }}
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedUserDetailApprove != undefined && (
                      <div>
                        <button
                          ref={modelButtonApprove}
                          type="button"
                          className="btn btn-primary d-none"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop1"
                        >
                          Launch static backdrop modal
                        </button>

                        <div
                          className="modal fade"
                          id="staticBackdrop1"
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"
                          tabindex="-1"
                          aria-labelledby="staticBackdrop1Label"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5
                                  className="modal-title"
                                  id="staticBackdrop1Label"
                                >
                                  Update Details
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              {/* <div className="modal-body">
                                    <TextField
                                      required={
                                        selectedUserDetailApprove != undefined
                                      }
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="msisdn1"
                                      variant="outlined"
                                      size="small"
                                      onChange={formik1.handleChange}
                                      value={formik1.values.msisdn1}
                                      error={
                                        formik1.touched.msisdn1 &&
                                        Boolean(formik1.errors.msisdn1)
                                      }
                                      helperText={
                                        formik1.touched.msisdn1 &&
                                        formik1.errors.msisdn1
                                      }
                                      
                                    />
                                  </div> */}
                              <div className="modal-body">
                                <div className="row">
                                  <div className="col-md-6 mt_2">
                                    <div class="col-6">
                                      <label
                                        for="exampleInputEmail1"
                                        className="form-label "
                                      >
                                        Mobile Number:
                                      </label>
                                    </div>
                                    {/* <input
                                          type="number"
                                          // title=""
                                          // pattern="[6789][0-9]{9}"
                                      
                                          // min="1000000000"
                                          // min="4"
                                        // max="10000000000"
                                          required
                                          value={phoneNumber}
                                          onChange={(e) => {
                                            setPhoneNumber(e.target.value);
                                          }}
                                          // value={selectedUserDetailApprove?.dltId}
                                          className="form-control"
                                          id="exampleInputEmail1"
                                          aria-describedby="emailHelp"
                                        /> */}
                                    <input
                                      type="number"
                                      // title=""
                                      // pattern="[6789][0-9]{9}"

                                      // min="1000000000"
                                      // min="4"
                                      // max="10000000000"
                                      required
                                      // value={phoneNumber1}
                                      // value=""
                                      // onChange={(e) =>
                                      //   handlechangenumber(e)
                                      // }
                                      // value={selectedUserDetailApprove?.dltId}
                                      className="form-control select_5"
                                      id="exampleInputEmail1"
                                      aria-describedby="emailHelp"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer justify-content-between">
                                <button
                                  type="button"
                                  className="btn btn-secondary w_btn20"
                                  data-bs-dismiss="modal"
                                  id="getcancel"
                                >
                                  Cancel
                                </button>
                                <button
                                  required
                                  type="submit"
                                  className="btn btn-primary editcolor"
                                  // onClick={changeModal}
                                  // data-bs-dismiss="modal"
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="container-fluid">
                      <div class="mb-3 mt-4">
                        <div class=" mt-2 table_overFlo">
                          <div>
                            {selectedFlatRows.length > 0 && (
                              <button onClick={deletUser}>Delete Users</button>
                            )}
                          </div>
                          <>
                            {/* <div class="wrapper1" ref={wrapper1Ref}>
                              <div class="div1" ref={div1Ref}>
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm"
                                  style={{ width: "100%" }}
                                >
                        <thead className="teble_scroll2">
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                // className="text-center"
                                                // className={
                                                //   (cell.column.Header == "Id" ||
                                                //     cell.column.Header ==
                                                //       "Total Upload" ||
                                                //     cell.column.Header ==
                                                //       "Allready Exist" ||
                                                //     cell.column.Header ==
                                                //       "Total Success" ||
                                                //     cell.column.Header ==
                                                //       "Total Failure") &&
                                                //   "text-end"
                                                // }

                                                className={
                                  cell.column.Header == "Id" ||
                                  cell.column.Header == "Total Upload" ||
                                  cell.column.Header == "Total Success" ||
                                  cell.column.Header == "Total Failure" ||
                                  cell.column.Header == "Allready Exist"
                                    ? "text-end"
                                    : cell.column.Header == "Status" ||
                                      cell.column.Header == "Download"
                                    ? "text-center"
                                    : "text-start"
                                }
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div> */}
                            <div
                              class="wrapper2 w-100"
                              style={{ overflowX: "hidden" }}
                              ref={wrapper2Ref}
                            >
                              <div class="div2 w-100" ref={div2Ref}>
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm"
                                  style={{ width: "100%" }}
                                >
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                // className="text-center"
                                                className={
                                                  cell.column.Header == "Id" ||
                                                  cell.column.Header ==
                                                    "Total Upload" ||
                                                  cell.column.Header ==
                                                    "Total Success" ||
                                                  cell.column.Header ==
                                                    "Total Failure" ||
                                                  cell.column.Header ==
                                                    "Allready Exist"
                                                    ? "text-end"
                                                    : cell.column.Header ==
                                                        "Status" ||
                                                      cell.column.Header ==
                                                        "Download"
                                                    ? "text-center"
                                                    : "text-start"
                                                }
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                          <div className="d-flex justify-content-between mt-3">
                            <div>
                              <span>
                                Page:
                                <strong>
                                  {data2?.pageable?.pageNumber + 1} of{" "}
                                  {data2?.totalPages}
                                </strong>
                              </span>
                              {/* <span>
                                | Go to Page :{""}
                                <input
                                  type="number"
                                  min="0"
                                  max={totalPage}
                                  // defaultValue={pageIndex}
                                  // defaultValue={totalPageCount}
                                  value={totalPageCount}
                                  // defaultValue={pageNumber1}
                                  onChange={(e) => {
                                    const pageNumber = e.target.value
                                      ? Number(e.target.value)
                                      : 0;
                                    gotoPage(pageNumber);
                                    setPageNumber1(pageNumber);
                                  }}
                                  style={{ width: "50px" }}
                                />
                              </span> */}
                            </div>

                            <div className="btn_n800">
                              <button
                                className="btn btn_primary "
                                type="button"
                                style={{ background: "#2C97D4" }}
                                disabled={data2?.pageable?.pageNumber == 0}
                                onClick={() => {
                                  setTableStatus({
                                    ...TableStatus,
                                    pageNo: TableStatus.pageNo - 1,
                                  });
                                }}
                              >
                                Prev
                              </button>

                              <button
                                className="btn btn_primary ms-2"
                                type="button"
                                style={{ background: "#2C97D4" }}
                                disabled={
                                  data2?.totalPages ==
                                  data2?.pageable?.pageNumber + 1
                                }
                                onClick={() => {
                                  setTableStatus({
                                    ...TableStatus,
                                    pageNo: TableStatus.pageNo + 1,
                                  });
                                }}
                              >
                                Next
                              </button>
                              {/* <button
                onClick={() => {
                  gotoPage(pageCount - 1);
                }}
                disabled={!canNextPage}
              >
                {">>"}
              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center mt-4">
                    {data?.length == 0 && open ? null : (
                      <h5 className="text-center mt-4">No Record Found..!!</h5>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ImportContact;
